import { z } from 'zod';

export interface Company {
  id?: string;
  name: string;
  status?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface NewCompany {
  name: string;
}

export const companySchema = z.object({
  name: z
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .max(100, 'Máximo 100 caracteres'),
});

export type CompanySchema = z.infer<typeof companySchema>;
